var React = require('react');

function SliderMobile (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"fill":"#ff4628","height":"32","rx":"16","width":"92","y":".029297","key":0}),React.createElement("g",{"stroke":"#fff","key":1},[React.createElement("path",{"d":"m46 11.0293v9.9999","key":0}),React.createElement("path",{"d":"m54 11.0293v9.9999","key":1}),React.createElement("path",{"d":"m38 11.0293v9.9999","key":2}),React.createElement("path",{"d":"m70 11.0293 6 5-6 5","key":3}),React.createElement("path",{"d":"m22 21.0293-6-5 6-5","key":4})])]);
}

SliderMobile.defaultProps = {"fill":"none","height":"33","viewBox":"0 0 92 33","width":"92"};

module.exports = SliderMobile;

SliderMobile.default = SliderMobile;
